export default __webpack_public_path__ + "static/BluePilot-9ee28128aa8b9457a56c26db2b45eb45.png";